import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconGoogleColor16 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	ref,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "#4285F4",
				d: "M14.027 8.136q-.002-.637-.11-1.227h-5.65V9.23h3.229a2.76 2.76 0 0 1-1.198 1.81v1.506h1.94c1.134-1.044 1.789-2.582 1.789-4.41"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#34A853",
				d: "M8.267 14c1.62 0 2.978-.537 3.97-1.454l-1.939-1.505c-.537.36-1.224.573-2.031.573-1.563 0-2.886-1.056-3.358-2.474H2.905v1.554A6 6 0 0 0 8.267 14"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#FBBC05",
				d: "M4.91 9.14A3.6 3.6 0 0 1 4.72 8c0-.395.068-.78.188-1.14V5.305H2.905a6 6 0 0 0 0 5.39z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#EA4335",
				d: "M8.267 4.386c.88 0 1.671.303 2.293.898l1.721-1.721C11.242 2.595 9.884 2 8.267 2a6 6 0 0 0-5.362 3.305L4.909 6.86c.472-1.418 1.795-2.474 3.358-2.474"
			})
		]
	})
});
const ForwardRef = forwardRef(SvgIconGoogleColor16);
export default ForwardRef;
